import { fetchFunds } from "../data";
import { IColumnMap, IDataEntity, IAppParams } from "../models";
import { getDisplayValue, getValueFromStringNotation, toDisplay } from "./";

export async function doFetchBuildCSV(options, appParams, columns: IColumnMap[], tab) {
    let funds = await fetchFunds('fund_key', Object.assign(options, { limit: 1000 }), appParams, "Print");
    let headingRow = columns.map(item => item.headerKey);
    let rows = [headingRow];
    const isPPL = appParams.productrange === "PPL";
    for (let fund of funds.values) {
        for (let shareClass of fund.shareClasses) {
            let isProperty = fund.properties["asset_class"] === "Property" || shareClass["properties"]["fund_key"] === "HIT";
            let row = [];
            for (let column of columns) {
                let value;
                if (column.entity === "fund") {
                    column.field = "properties.fund_name";
                    value = getValueFromStringNotation(column.field, shareClass);
                    value = getDisplayValue(value, column);
                }
                else if (column.headerKey === "Mstar Rating") {
                    column.field = "properties.morningstar_rating";
                    column.type = "number";
                    value = getValueFromStringNotation(column.field, shareClass);
                    value = getDisplayValue(value, column);
                }
                else if (column.headerKey === "Mstar Analyst Rating") {
                    column.field = "properties.analyst_rating";
                    column.type = "number";
                    value = getValueFromStringNotation(column.field, shareClass);
                    value = getDisplayValue(value, column);
                }
                else if (column.headerKey === 'Bid / Offer Prices') {
                    if (!isProperty && !isPPL) {
                        value = "n/a";
                    }
                    else {
                        let values = column.fields.map(item => getDisplayValue(getValueFromStringNotation(item, shareClass), column));
                        value = values.join(column.fieldSeperator);
                    }
                }
                else {
                    if (column.headerKey === "Price" && isProperty && !isPPL) {
                        value = "n/a";
                    }
                    else {
                        value = getValueFromStringNotation(column.field, shareClass);
                        value = getDisplayValue(value, column);
                    }
                }

                if (column.isPerformance && value !== "-") {
                    value = `${value}%`;
                }

                row.push(value);
            }
            rows.push(row);
        }
    }

    return await exportToCsv(toDisplay(tab), rows);
}

export function filterColumnsCSV(columns: IColumnMap[], isPPL: boolean): IColumnMap[] {
    return columns
        .filter(item => {
            return (item.headerKey === "Fund Name") || (item.isCSV && !item.explicitHide)
        }).map(item => {
            let { headerKey, type, field, fields, entity, isPerformance, fieldSeperator } = item;
            let result = { headerKey, type, field, fields, entity, isPerformance, fieldSeperator };
            return result;
        });
}

export function getShareDocumentByType(shareClass: IDataEntity, appParams: IAppParams, type: string) {
    let { language, clienttype, region } = appParams
    let [doc] = shareClass.documents.filter(item => {
        let isValidDoc = item.meta.document_type.value === type &&
            item.meta.client_type.value === clienttype &&
            item.meta.language.value === language &&
            item.meta.registration.value === region;

        if (isValidDoc) {
            return item;
        }
    });
    if (doc) {
        return doc.URL;
    } else {
        return "-";
    }
}

export async function exportToCsv(filename, rows) {
    let processRow = function (row) {
        let finalVal = '';
        for (let j = 0; j < row.length; j++) {
            let innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            let result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    let csvFile = '';
    for (let i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    let blob = new Blob(["\ufeff", csvFile], { type: 'text/csv;charset=ISO-8859-1;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, `${filename}.csv`);
    } else {
        let link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `${filename}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return true;
}

export function downloadPDF(url, filename) {
    let win = window.open(url, '_blank');
    win.focus();
    // let event;
    // if (document.createEvent) {
    //     // To create a mouse event , first we need to create an event and then initialize it.
    //     event = document.createEvent("MouseEvent");
    //     event.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    // }
    // else {
    //     event = new MouseEvent('click', {
    //         'view': window,
    //         'bubbles': true,
    //         'cancelable': true
    //     });
    // }

    // let link = document.createElement('a');
    // link.href = url;
    // link.download = `${ filename }.pdf`;
    // link.dispatchEvent(event);
    // link = null;
}


// WEBPACK FOOTER //
// ./src/client/utils/export.ts